export default __webpack_public_path__ + "static/media/Shrieking Wind.70cfa1d7.jpg";